export const moduleSnackbar = {
  namespaced: true,

  state: {
    message: '',
    color: 'success'
  },

  getters: {
  },

  mutations: {

    SET_SUCCESS(state, message) {
      state.color = 'success';
      state.message = message;
    },

    SET_ERROR(state, message) {
      state.color = 'error';
      state.message = message;
    },

    SET_INFO(state, message) {
      state.color = 'info'
      state.message = message;
    }
  }

}